import React from 'react';

function SliderGridProductCardSkeleton() {
  return (
    <section className="flex gap-x-[8px] gap-y-[12px] md:gap-x-[16px] md:gap-y-[24px] w-full overflow-x-hidden">
      {Array(10)
        .fill(null)
        .map((_, index) => (
          <div
            key={index}
            className="space-y-3 animate-pulse bg-pale-grey w-[170px] lg:w-[298px] h-full max-h-[366px] lg:max-h-[563px] shadow-trending-categories-search rounded-8 relative overflow-hidden my-2 flex-shrink-0"
          >
            <div className="h-[128px] sm:h-[236px] bg-skeleton rounded-[4px] relative">
              <div className="absolute left-0 right-0 bottom-[6px] flex gap-[6px] justify-center">
                <span className="size-[10px] bg-himalayan-poppy rounded-full" />
                <span className="h-[10px] w-[30px] bg-himalayan-poppy rounded-[100px]" />
                <span className="size-[10px] bg-himalayan-poppy rounded-full" />
              </div>
            </div>

            <div className="px-10 pb-10 space-y-3">
              <div className="h-[14px] sm:h-[18px] bg-skeleton rounded-[4px] max-w-20" />
              <div className="h-[40px] sm:h-14 bg-skeleton rounded-[4px] w-full" />

              <div className="h-[16px] sm:h-5 max-w-[105px] bg-skeleton rounded-[4px]" />
              <div className="h-[56px] sm:h-[81px] max-w-[119px] bg-skeleton rounded-[4px]" />

              <div className="h-[20px] sm:h-[28px] bg-skeleton rounded-[4px]" />
              <div className="h-[24px] sm:h-[40px] bg-skeleton rounded-[4px]" />
            </div>
          </div>
        ))}
    </section>
  );
}

export default SliderGridProductCardSkeleton;
